export enum UserCapabilityName {
  // AIM
  SuperAdmin = 'Super Admin',
  CreateAccessPolicy = 'Create Access Policy',
  CreateCapability = 'Create Capability',
  CreateInternalAccessPolicy = 'Create Internal Access Policy',
  CreateOrganization = 'Create Organization',
  CreateService = 'Create Service',
  CreateInternalUser = 'Create Internal User',
  CreateUser = 'Create User',
  DeleteAccessPolicy = 'Delete Access Policy',
  DeleteCapability = 'Delete Capability',
  DeleteInternalAccessPolicy = 'Delete Internal Access Policy',
  DeleteOrganization = 'Delete Organization',
  DeleteService = 'Delete Service',
  DeleteInternalUser = 'Delete Internal User',
  DeleteUser = 'Delete User',
  EditAccessPolicy = 'Edit Access Policy',
  EditCapability = 'Edit Capability',
  EditInternalAccessPolicy = 'Edit Internal Access Policy',
  EditOrganization = 'Edit Organization',
  EditService = 'Edit Service',
  EditInternalUser = 'Edit Internal User',
  EditUser = 'Edit User',
  EndUserAllAdmin = 'End User All Admin',
  ViewAccessPolicies = 'View Access Policies',
  ViewCapabilities = 'View Capabilities',
  ViewInternalAccessPolicies = 'View Internal Access Policies',
  ViewOrganizations = 'View Organizations',
  ViewServices = 'View Services',
  ViewEventLogs = 'View Event Logs',
  ViewInternalUsers = 'View Internal Users',
  ViewUsers = 'View Users',
  InternalEdit = 'Internal Edit',
  InternalView = 'Internal View',
  OrganizationsAllView = 'Organizations All View',
  ViewReports = 'View Reports',
  EndUserBilling = 'End User Billing',
  EditMultiOrgUser = 'Edit Multi-Org User',

  // Senet
  ManageNetworkEdgeAdministrator = 'Manage Network Edge Administrator',
  ManageTickets = 'Manage Tickets',
  ManageVoiceFeatures = 'Manage Voice Features',
  StorageCreateFiles = 'Storage Create Files',
  StorageDeleteFiles = 'Storage Delete Files',
  StorageEditFiles = 'Storage Edit Files',
  StorageReadFiles = 'Storage Read Files',
  PayBill = 'Pay Bill',
  ViewBills = 'View Bills',
  ViewCallDetailRecords = 'View Call Detail Records',
  ViewLocationsAndDetails = 'View Locations and Details',
  LoginAccess = 'Login Access',
  TechnicalSupportTickets = 'Technical Support Tickets',
  UserManagement = 'User Management',
  // Eleven
  CharterSupport = 'Charter Support',
  ManagedSecurityServiceAdministrator = 'Managed Security Service Administrator',
  SDWANAdmin = 'SD-WAN Admin',
  SiteEvent = 'Site Event',
  CharterEngineer = 'Charter Engineer',
  // Managed Network Edge
  CharterMNEUser = 'Charter MNE User',
  MNEAdmin = 'MNE Admin',
  CharterMNEAdmin = 'Charter MNE Admin',
  MNEVideoNetwork = 'MNE Video Network',
  MNEUser = 'MNE User',
  // Managed Network Edge Site Manager
  CharterTeamAdmin = 'Charter Team Admin',
  CharterTeamUser = 'Charter Team User',
  MNESiteAdmin = 'Site Admin',
  MNESiteUser = 'Site User',
  // DUO
  DuoAdmin = 'Duo Admin',
  CharterOwner = 'Charter Owner',
  CharterAdmin = 'Charter Admin',
  DuoOwner = 'Duo Owner',
  CharterUser = 'Charter User',
  DuoUser = 'Duo User',
  // Video Client Portal
  CPCharterAdmin = 'CP Charter Admin',
  CPCharterUser = 'CP Charter User',
  CPActivityLog = 'CP Activity Log',
  CPChannelMask = 'CP Channel Mask',
  CPDevices = 'CP Devices',
  CPMetrics = 'CP Metrics',
  CPReadOnly = 'CP Read Only',
  CPViewer = 'CP Viewer',
  CPViewingArea = 'CP Viewing Area',
  // Video SpecU
  LoginSpecU = 'Login SpecU',
  // Video TVSA
  LoginTVSA = 'Login TVSA',

  // TV Portal Service
  CreateChannels = 'Create Channels',
  CreateDevices = 'Create Devices',
  CreateViewers = 'Create Viewers',
  DeleteChannels = 'Delete Channels',
  DeleteDevices = 'Delete Devices',
  DeleteViewers = 'Delete Viewers',
  EditChannels = 'Edit Channels',
  EditDevices = 'Edit Devices',
  EditViewers = 'Edit Viewers',
  UploadVideo = 'Upload Video',
  ViewChannels = 'View Channels',
  ViewDevices = 'View Devices',
  ViewLogs = 'View Logs',
  ViewViewers = 'View Viewers',
}

export const toUserCapabilityEnum = (val: string): UserCapabilityName => {
  return UserCapabilityName[val as keyof typeof UserCapabilityName];
};
